import { manutencao_sequencia_de_geracao_de_estimativa } from "./manutencao-sequencia-de-geracao-de-estimativa";
import { geracao_de_contantes_alunos_novos } from "./geracao-de-constantes-alunos-novos";
import { geracao_estimativa_de_matricula_com_reordenamento_contraturno } from "./geracao-estimativa-de-matricula-com-reordenamento-contraturno";
import { manutencao_do_ensino_anterior } from "./manutencao-do-ensino-anterior";
import { ajuste_estimativa_de_matricula_reordenamento_alunos_novos } from "./ajuste-estimativa-de-matricula-reordenamento-alunos-novos";
import { gerar_arquivo_de_planejamento_matricula } from "./gerar-arquivo-de-planejamento-matricula";
import { geracao_relatorio_inconsistencias_planejamento_reordenamento } from "./geracao-relatorio-inconsistencias-planejamento-reordenamento";
import { des_bloquear_geracao_da_estimativa_matricula } from "./des-bloquear-geracao-da-estimativa-matricula";
import { des_confirmar_estimativa_de_matricula_por_escola } from "./des-confirmar-estimativa-de-matricula-por-escola";
import { confirmar_estimativa_de_matricula_por_rede } from "./confirmar-estimativa-de-matricula-por-rede";
import { consulta_planejamento_matricula } from "./consulta-planejamento-matricula";
import { consulta_constante_de_alunos_novos } from "./consulta-constante-de-alunos-novos";
import { manutencao_estimativa_matricula } from "./manutencao-estimativa-matricula";

const estimativa_de_matricula = [
  manutencao_estimativa_matricula,
  manutencao_sequencia_de_geracao_de_estimativa,
  geracao_de_contantes_alunos_novos,
  geracao_estimativa_de_matricula_com_reordenamento_contraturno,
  manutencao_do_ensino_anterior,
  ajuste_estimativa_de_matricula_reordenamento_alunos_novos,
  gerar_arquivo_de_planejamento_matricula,
  geracao_relatorio_inconsistencias_planejamento_reordenamento,
  des_bloquear_geracao_da_estimativa_matricula,
  des_confirmar_estimativa_de_matricula_por_escola,
  confirmar_estimativa_de_matricula_por_rede,
  consulta_planejamento_matricula,
  consulta_constante_de_alunos_novos,
];

export { estimativa_de_matricula };
